
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teachers/curriculum",
      function () {
        return require("private-next-pages/teachers/curriculum/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teachers/curriculum"])
      });
    }
  